<template lang="pug">
b-navbar.header-upper-navbar
  .empty
  b-nav(:is-navbar="true")
    b-nav-text
      span.cif {{ cif }}
      span -
      span.tradename(v-if="typePerson==='LP'") {{ tradeName }}
      span.tradename(v-else) {{ name }}
      span -
      span.username {{ username }}
  b-nav.right(:is-navbar="true")
    b-nav-item-dropdown(:text="language.name")
      b-dropdown-item(v-for="lang in languageOptions" :key="lang.id")
        a(
          @click="language = lang.id"
          value-field="id"
          text-field="name"
          :data-vv-as="$t('menus.topmenu.header.language')") {{ lang.name }}
    b-nav-item
      a(href='javascript:void(0)', alt='Sign out' title="Cerrar sesión" @click="logout")
        i.menuIcon(class="icon-top-menu icon-logout")
</template>

<script>
import { setCookie } from '@/utils/utils'
import session from '@/auth/session'
import config from '@/utils/config'
import i18n from '@/i18n'

export default {
  name: 'header-upper-navbar',
  computed: {
    logo: {
      get () {
        return `/static/img/${config.logo}`
      }
    },
    userCifOptions: {
      get() {
        return [
          {
            id: this.$store.state.me.document,
            name: this.$store.state.me.document
          }
        ]
      }
    },
    cif: {
      get () {
        return this.$store.state.me.document
      },
      set (value) {
        this.$store.state.me.document = value
      }
    },
    tradeName: {
      get() {
        return this.$store.state.me.tradeName
      }
    },
    /**
     * Represents the stored username
     * @return {String|undefined} Current username
     */
    username: () => session.getSecValue('username'),
    languageOptions: {
      get() {
        return [
          {
            id: 'es',
            name: 'ES'
          },
          {
            id: 'en',
            name: 'EN'
          },
          {
            id: 'pt',
            name: 'PT'
          }
        ]
      }
    },
    language: {
      get () {
        return this.languageOptions.find(x => x.id === i18n.locale)
      },
      set (value) {
        i18n.locale = value
      }
    },
    name: {
      get () {
        return this.$store.state.me.name
      }
    },
    typePerson: {
      get () {
        return this.$store.state.me.type
      }
    }
  },
  methods: {
    logout() {
      setCookie(config.jwtCookieName, '', 0) // Borramos la cookie
      session.destroy() // Borramos datos sesión
      this.$router.push('/login')
    }
  },
  mounted () {
    Promise.all([
      this.$store.dispatch('me/get')
    ]).then((result) => {})
  }
}
</script>
